import request from '@/utils/request'
export function selectPieceworkCountByOperator(data) {
    return request({
        url: `api/serviceCenter/orderManagement/selectPieceworkCountByOperator`,
        method: 'post',
        data,
    })
}

export function selectOperatorInfo(data) {
    return request({
        url: `api/serviceCenter/orderManagement/selectOperatorInfo`,
        method: 'post',
        data,
    })
}

export function downLoadPieceworkCountByOperator(data) {
    return request({
      url: `api/serviceCenter/orderManagement/downLoadPieceworkCountByOperator`,
      method: 'post',
      responseType: 'blob',
      data
    })
  }

  
  export function downLoadOperatorInfo(data) {
    return request({
      url: `api/serviceCenter/orderManagement/downLoadOperatorInfo`,
      method: 'post',
      responseType: 'blob',
      data
    })
  }